<template>
  <v-form
      ref="form"
      lazy-validation
      v-model="formValid"
      v-if="item != null"
  >
    <v-alert :value="formError" color="error" class="pb-2">{{ formError }}</v-alert>

    <v-text-field
        v-model="item.name"
        :label="$t('name')"
        :rules="[v => !!v || $t('name_required')]"
        required
        :disabled="formSaving"
        outlined
        dense
    />

    <v-text-field
        v-model.trim="item.image_prefix"
        :label="$t('eeBuildImagePrefix')"
        :hint="$t('eeBuildImagePrefixHint')"
        persistent-hint
        :rules="[v => !!v || $t('eeBuildImagePrefixRequired')]"
        required
        :disabled="formSaving"
        outlined
        dense
    />

    <v-text-field
        v-model.trim="item.registry_url"
        :label="$t('eeBuildRegistryUrl')"
        :hint="$t('eeBuildRegistryUrlHint')"
        persistent-hint
        :disabled="formSaving"
        outlined
        dense
    />

    <v-autocomplete
        v-model="item.registry_credential_key_id"
        :label="$t('eeRegistryCredential')"
        :items="loginPasswordKeys"
        item-value="id"
        item-text="name"
        :hint="$t('eeRegistryCredentialHint')"
        persistent-hint
        clearable
        :disabled="formSaving"
        outlined
        dense
    />

    <v-textarea
        v-model="item.definition"
        :label="$t('eeBuildDefinition')"
        :placeholder="defPlaceholder"
        :hint="$t('eeBuildDefinitionHint')"
        persistent-hint
        outlined
        dense
        rows="14"
        :rules="[v => !!v || $t('eeBuildDefinitionRequired')]"
        :disabled="formSaving"
        spellcheck="false"
        style="font-family: 'Commit Mono', ui-monospace, monospace;"
    />
  </v-form>
</template>
<script>
import axios from 'axios';
import ItemFormBase from '@/components/ItemFormBase';

export default {
  mixins: [ItemFormBase],
  data() {
    return { keys: [] };
  },
  computed: {
    loginPasswordKeys() {
      return (this.keys || []).filter((k) => k.type === 'login_password');
    },
    defPlaceholder() {
      return [
        'version: 3',
        '',
        'images:',
        '  base_image:',
        "    name: 'quay.io/centos/centos:stream9'",
        '',
        'dependencies:',
        '  galaxy: requirements.yml',
        '  python: requirements.txt',
        '  system: bindep.txt',
      ].join('\n');
    },
  },
  async created() {
    try {
      const { data } = await axios.get(`/api/project/${this.projectId}/keys`);
      this.keys = Array.isArray(data) ? data : [];
    } catch (e) {
      this.keys = [];
    }
  },
  methods: {
    getNewItem() {
      return {
        name: '',
        image_prefix: '',
        registry_url: '',
        registry_credential_key_id: null,
        definition: '',
      };
    },
    getItemsUrl() {
      return `/api/project/${this.projectId}/ee_builds`;
    },
    getSingleItemUrl() {
      return `/api/project/${this.projectId}/ee_builds/${this.itemId}`;
    },
  },
};
</script>
